export const exceptionCurriBook = [36551, 36542, 36579, 36601,
    // 고등
    36583, // 대수
    36584, // 미적분1
    36585, // 확률과 통계
    36580, // 공통수학2
    36602, // 통합과학2
    36605, // 물리학
    36607, // 생명과학
    36608, // 지구과학
    // 중학
    69553, // 과학2
    69125, // 중-수학2
    69102, // 고-기하
    69114, // 고-미적분2
    36609, // 고-역학
    36611, // 고-물질
    36613, // 고-물질대사
    36615, // 고-지구시스템과학
]; // 3뎁스 표기 교과서

export const normalizeDifficulty = (difficulty: string): string => {
    if (difficulty?.includes('중')) {
        return '중'; // "중하", "중상"도 전부 "중"
    }
    return difficulty;
};

export const getSuffix = (title: string): string => {
    if (!title || title.length === 0) return '';

    const lastChar = title[title.length - 1];
    const code = lastChar.charCodeAt(0);

    if (code >= 0xac00 && code <= 0xd7a3) {
        const jongseongIndex = (code - 0xac00) % 28;
        return jongseongIndex === 0 ? '를' : '을';
    } else {
        return '을';
    }
};

export const str = {
    padding: (n: number, digit: number, pad: string, dir: 'left' | 'right' = 'left'): string => {
        let result = n.toString();
        const pCount = digit - result.toString().length;
        if (pCount > 0) {
            const p = pad.substring(0, 1);
            for (let i = 0; i < pCount; i++) {
                if (dir == 'left') {
                    result = p + result;
                } else {
                    result += p;
                }
            }
        }
        return result;
    },
    arrayToStr: (arr: any[], sep: string = ',') => {
        if (arr.length > 0) {
            const sSet = new Set(); // 중복 제거
            arr.map((item) => {
                if (item != undefined && item != null) {
                    sSet.add(item.toString());
                }
            });
            return Array.from(sSet).join(sep);
        }
        return '';
    },

    maxLength: (str?: string, max: number = 50, ellipsis: string = '') => {
        if (str == undefined || str == null) return '';
        return str.length <= max ? str : str.substring(0, max) + ellipsis;
    },
};
